import { render } from "./personalPosts.vue?vue&type=template&id=55abe936&scoped=true"
import script from "./personalPosts.vue?vue&type=script&lang=js"
export * from "./personalPosts.vue?vue&type=script&lang=js"

import "../../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./personalPosts.vue?vue&type=style&index=1&id=55abe936&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55abe936"]])

export default __exports__